import tinycolor from 'tinycolor2'

const primary = '#176DFB'
const secondary = '#6e7b92'
const warning = '#FFC260'
const success = '#3CD4A0'
const info = '#9013FE'
const error = '#ff6961'

const lightenRate = 7.5
const darkenRate = 15

export default {
  palette: {
    primary: {
      main: primary,
      light: tinycolor(primary)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(primary)
        .darken(darkenRate)
        .toHexString()
    },
    secondary: {
      main: secondary,
      light: tinycolor(secondary)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(secondary)
        .darken(darkenRate)
        .toHexString(),
      contrastText: '#FFFFFF'
    },
    warning: {
      main: warning,
      light: tinycolor(warning)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(warning)
        .darken(darkenRate)
        .toHexString()
    },
    success: {
      main: success,
      light: tinycolor(success)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(success)
        .darken(darkenRate)
        .toHexString()
    },
    error: {
      main: error,
      light: tinycolor(error)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(error)
        .darken(darkenRate)
        .toHexString()
    },
    info: {
      main: info,
      light: tinycolor(info)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(info)
        .darken(darkenRate)
        .toHexString()
    },
    text: {
      primary: '#1A1A1A',
      secondary: '#8e8e8e',
      hint: '#B9B9B9'
    },
    background: {
      default: '#F0F3F7',
      light: '#F3F5FF'
    }
  },
  customShadows: {
    widget:
      '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetDark:
      '0px 3px 18px 0px #4558A3B3, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetWide:
      '0px 12px 33px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A'
  },
  overrides: {
    MuiInputBase: {
      input: {
        backgroundColor: '#F4F4F4',
        borderRadius: 10,
        '&:hover': {
          backgroundColor: '#E4E4E4'
        },
        '&:focus': {
          backgroundColor: '#E4E4E4'
        }
      }
    },
    MuiOutlinedInput: {
      notchedOutline: {
        border: 0,
        padding: 0
      },
      multiline: {
        padding: 0
      },
      inputMultiline: {
        padding: 15
      }
    },
    MuiPaper: {
      elevation4: {
        boxShadow: '0 0 3px 3px #eeeeee'
      }
    },
    MuiMenu: {
      paper: {
        boxShadow:
          '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A'
      }
    },
    MuiSelect: {
      icon: {
        color: '#B9B9B9'
      },
      root: {
        padding: 16
      },
      outlined: {
        borderRadius: 10,
        padding: 16,
        '&:focus': {
          borderRadius: 10
        }
      }
    },
    MuiListItem: {
      root: {
        '&$selected': {
          backgroundColor: '#F3F5FF !important',
          '&:focus': {
            backgroundColor: '#F3F5FF'
          }
        }
      },
      button: {
        '&:hover, &:focus': {
          backgroundColor: '#F3F5FF'
        }
      }
    },
    MuiTouchRipple: {
      child: {
        backgroundColor: 'white'
      }
    },
    MuiTableCell: {
      root: {
        borderBottom: '1px solid rgba(224, 224, 224, .5)'
      },
      head: {
        fontSize: '0.95rem'
      },
      body: {
        fontSize: '0.95rem'
      }
    },
    MuiExpansionPanel: {
      root: {
        backgroundColor: '#81b0fa0f',
        boxShadow: 'none',
        border: '1px solid #81b0fa'
      }
    }
  }
}
